import { DisabledPrompt } from "@bcm-dev/bcms-vite";
import { CustomModalContent, EDEStatementsCustomModal } from "components/custom-ui/CustomModal";
import { FormContainer, FormRowView } from "components/shared";
import { Document } from "model";
import "./styles.css";
import "./mobile.css";


/**
 * @function EDEHistoryModal
 * @return {React.Component}
 * @exported true
 * @description The main component for the EDEHistoryModal
 */
export default function EDEHistoryModal(props) {
    const data = props.data.data ?? {};
    const ui = props.data.ui ?? {};
    const account = data.account ?? {};
    const documents = Document.sortDateAscending(Document.initAll())
    .filter(item => item.account.id === account.id);
    
    const documentsContentData = documents.reduce((acc, doc) => {
        const year = doc.date.yearInt;

        if(acc.length === 0) {
            acc.push({
                id: year,
                year: year,
                documents: documents.filter(_doc => _doc.date.yearInt === year)
            });
        } else {
            var isIncluded = false;

            acc.map((currDocObj) => {
                if(currDocObj.year === year) {
                    isIncluded = true;
                }
            });

            if(!isIncluded) {
                acc.push({
                    id: year,
                    year: year,
                    documents: documents.filter(_doc => _doc.date.yearInt === year)
                });
            }
        }

        return acc;
    }, []);

    const documentsContent = documentsContentData.reduce((acc, item) => {
        acc.push(
            <HistorySection key={ item.year } documentData={ item } />
        )
        return acc;
    }, []);

    return (
        <EDEStatementsCustomModal id="EDEHistoryModal" title={ `View History - ${ account.name } - ${ account.number }`} className="ede-history-modal" dataPoint="EDE_Statements_History_Modal">
            <CustomModalContent>
                <FormContainer>{ documentsContent }</FormContainer>
            </CustomModalContent>
        </EDEStatementsCustomModal>
    );
}

function HistorySection(props) {
    const documentData = props.documentData;

    const documentLinks = documentData.documents.reduce((acc, item, index) => {
        acc.push(
            <li key={ item.id }>
                <DisabledPrompt>
                    <a className="clickable" data-point={ `EDE_Statements_View_History_Item_${ index }` }>{ item.date.format("M d, Y") }</a>
                </DisabledPrompt>
            </li>
        )
        return acc;
    }, []);

    return (
        <ul>
            <FormRowView>
            <li>{ documentData.year }</li>
            <ul className="circle">{ documentLinks }</ul>
             </FormRowView>
        </ul>
    );
}
